
export default "/assets/arrow-down-tray-micro.38d88e7d.svg"